module.exports = __webpack_public_path__ + "static/media/feature-app2.debb9345.png";